export const navigationDropdown = [
  { name: 'My Account', value: 'My Account' },
  { name: 'Nav option 1', value: 'Nav option 2' },
  { name: 'Nav option 2', value: 'Nav option 2' },
];
